import React, { FC } from 'react'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { useModal } from 'utils/hooks'
import { PendingAppointmentsModal } from './PendingAppointmentsModal'
import { TSchedulingTabOnHoldStops } from './types'

interface IFacilityPendingAppointmentsProps {
  onHoldStops: TSchedulingTabOnHoldStops
}

const pendingAppointmentsModal = 'pendingAppointmentsModal'

export const FacilityPendingAppointments: FC<IFacilityPendingAppointmentsProps> = ({
  onHoldStops,
}) => {
  const { closeModal, isOpen: isModalOpen, openModal } = useModal()

  if (!onHoldStops?.length) {
    return null
  }

  return (
    <>
      <InlineMessage
        cta={{
          action: openModal(pendingAppointmentsModal),
          label: 'View',
        }}
        message={`${onHoldStops?.length} appointment needs to be confirmed`}
        type={INLINE_MESSAGE_VARIANTS.INFO}
      />
      {isModalOpen(pendingAppointmentsModal) && (
        <PendingAppointmentsModal
          onClose={closeModal}
          onCancel={closeModal}
          open
          onHoldStops={onHoldStops}
        />
      )}
    </>
  )
}
